import { useLingui } from '@lingui/react/macro';

import PetBlock from '@rover/components/src/PetBlock/PetBlock';
import { Box, Flex, Heading } from '@rover/kibble/core';
import type { Pet } from '@rover/rsdk/src/apiClient/latest/model/pet';
import type { UnitEnum } from '@rover/rsdk/src/apiClient/latest/model/unitEnum';

type Props = {
  pets: Pet[];
  weightLabel: UnitEnum;
  onPetPressed?: (pet: Pet) => void;
};

const RevampSitterPets = ({ pets, weightLabel, onPetPressed }: Props): JSX.Element | null => {
  const { t } = useLingui();
  if (pets.length === 0) return null;

  return (
    <Box width="100%" py="10x">
      <Heading size="200" mb="4x" webProps={{ as: 'h3' }}>
        {t`Pets`}
      </Heading>
      <Flex
        flexDirection={['column', 'column', 'row']}
        flexWrap="wrap"
        sx={{ columnGap: ['0px', '0px', '56px'], rowGap: ['6x', '6x', '6x'] }}
      >
        {pets.map((pet, index) => (
          <Box
            key={pet.webUrl || `${pet.name}-${index}`}
            width={['100%', '100%', 'calc(50% - 28px)']}
          >
            <PetBlock
              pet={pet}
              weightLabel={weightLabel}
              onPetPressed={onPetPressed}
              dataTestId={pet.name}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default RevampSitterPets;
